"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _styles = require("@material-ui/core/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["children", "classes", "dataMetrics", "tabsAlign", "indicatorAlign", "indicatorHide", "mode", "variant"];
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    indicator: {},
    indicatorBottom: {
      bottom: 0
    },
    indicatorHide: {
      display: 'none'
    },
    indicatorTop: {
      top: 0
    },
    root: {
      flexGrow: 1
    },
    rootStatic: {},
    scrollButtons: {
      '& svg': {
        color: theme.palette.opacity.black[87],
        fontSize: '24px'
      },
      flexBasis: 32,
      order: 2
    },
    tabAlignment: {
      justifyContent: function justifyContent(_ref) {
        var tabAlignment = _ref.tabAlignment;
        return tabAlignment || 'flex-start';
      }
    },
    tabsDivider: {
      boxShadow: function boxShadow(_ref2) {
        var isStatic = _ref2.isStatic;
        return isStatic ? "inset 0px -1px ".concat(theme.palette.opacity.black[14]) : 'none';
      }
    }
  };
});
var TabGroup = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _cx;
  var children = props.children,
    flexContainerClass = props.classes.flexContainer,
    dataMetrics = props.dataMetrics,
    tabsAlign = props.tabsAlign,
    indicatorAlign = props.indicatorAlign,
    indicatorHide = props.indicatorHide,
    mode = props.mode,
    variant = props.variant,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var alignmentMap = {
    center: 'center',
    left: 'flex-start',
    right: 'flex-end'
  };
  var tabAlignment = alignmentMap[tabsAlign];
  var isStatic = mode === 'static';
  var classes = useStyles({
    isStatic: isStatic,
    tabAlignment: tabAlignment
  });
  return /*#__PURE__*/_react["default"].createElement(_Tabs["default"], (0, _extends2["default"])({
    classes: {
      flexContainer: (0, _classnames["default"])(classes.tabsDivider, classes.tabAlignment, flexContainerClass),
      indicator: (0, _classnames["default"])(classes.indicator, (_cx = {}, (0, _defineProperty2["default"])(_cx, classes.indicatorTop, indicatorAlign === 'top'), (0, _defineProperty2["default"])(_cx, classes.indicatorBottom, indicatorAlign === 'bottom'), (0, _defineProperty2["default"])(_cx, classes.indicatorHide, indicatorHide), _cx)),
      root: (0, _classnames["default"])((0, _defineProperty2["default"])({}, classes.root, classes.root)),
      scrollButtons: classes.scrollButtons
    },
    "data-metrics": dataMetrics.root,
    ref: ref,
    variant: variant
  }, rest), children);
});
TabGroup.defaultProps = {
  dataMetrics: {
    root: 'fuse_tabs'
  },
  indicatorAlign: 'top',
  indicatorColor: 'primary',
  indicatorHide: false,
  tabsAlign: 'left'
};
TabGroup.displayName = 'TabGroup';
TabGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports `updateIndicator()` action.
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: _propTypes["default"].func,
  /**
   * If `true`, the tabs will be centered.
   * This property is intended for large views.
   */
  centered: _propTypes["default"].bool,
  /**
   * The content of the component.
   */
  children: _propTypes["default"].node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].object]),
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * Determines the alignment of the `Tabindicator`.
   */
  indicatorAlign: _propTypes["default"].oneOf(['top', 'bottom']),
  /**
   * Determines the color of the indicator.
   */
  indicatorColor: _propTypes["default"].oneOf(['secondary', 'primary']),
  /**
   * If 'true', indicator will be hidden.  It is intended to be used in dark background.
   */
  indicatorHide: _propTypes["default"].bool,
  /**
   *  `dynamic` for closable tabs `static` ( default ) for traditional tabs. These will be centered text and no padding.
   */
  mode: _propTypes["default"].string,
  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {number} value We default to the index of the child
   */
  onChange: _propTypes["default"].func,
  /**
   * The component used to render the scroll buttons.
   */
  ScrollButtonComponent: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].object]),
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll
   * `auto` will only present them on medium and larger viewports
   * `on` will always present them
   * `off` will never present them
   */
  scrollButtons: _propTypes["default"].oneOf(['auto', 'on', 'off']),
  /**
   * Properties applied to the `TabIndicator` element.
   */
  TabIndicatorProps: _propTypes["default"].object,
  /**
   * Determines the Tab alignment of inside Tabs.
   */
  tabsAlign: _propTypes["default"].oneOf(['left', 'right', 'center']),
  /**
   * Determines the color of the `Tab`.
   */
  textColor: _propTypes["default"].oneOf(['secondary', 'primary', 'inherit']),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this property to `false`.
   */
  value: _propTypes["default"].any,
  /**
   *  Determines additional display behavior of the tabs:
   *
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   *  - `scrollable` allows Mui-Tabs to scroll.
   */
  variant: _propTypes["default"].oneOf(['standard', 'scrollable', 'fullWidth'])
} : {};
var _default = TabGroup;
exports["default"] = _default;